
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { useCTraderAccounts } from '@/hooks/use-ctrader-accounts';

interface CTraderProfileFieldProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export const CTraderProfileField: React.FC<CTraderProfileFieldProps> = ({
  form,
  disabled = false,
}) => {
  const { data: ctraderAccounts, isLoading: isLoadingAccounts } = useCTraderAccounts();

  return (
    <FormField
      control={form.control}
      name="csp_account_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Ctrader Profile</FormLabel>
          <Select
            onValueChange={field.onChange}
            value={field.value}
            disabled={isLoadingAccounts || disabled}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a Ctrader profile" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {isLoadingAccounts ? (
                <SelectItem value="loading" disabled>Loading profiles...</SelectItem>
              ) : ctraderAccounts && ctraderAccounts.length > 0 ? (
                ctraderAccounts.map(account => (
                  <SelectItem key={account.id} value={account.id}>
                    {account.csp_account_name} 
                    {account.broker && ` - ${account.broker}`}
                    {account.prop_firm && ` - ${account.prop_firm}`}
                  </SelectItem>
                ))
              ) : (
                <SelectItem value="none" disabled>No profiles found</SelectItem>
              )}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
